import { render, staticRenderFns } from "./DictSearchModal.vue?vue&type=template&id=901d5bd0&scoped=true"
import script from "./DictSearchModal.vue?vue&type=script&lang=js"
export * from "./DictSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901d5bd0",
  null
  
)

export default component.exports